import React from 'react'
import { isSite } from '~/tools/isSite'

class NextVideoTimer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      timer: props.timer
    }

    this.changeTimer = this.changeTimer.bind(this)
  }

  componentDidMount() {
    this.interval = setInterval(this.changeTimer, 1000)
  }

  changeTimer(){
    this.setState({ timer: this.state.timer - 1 })
    if (this.state.timer <= 0) {
      clearInterval(this.interval)
      this.props.action()
    }
  }

  render() {
    const background = {
      background: `url(${this.props.backgroundUrl}) no-repeat`,
      backgroundSize: 'cover',
    }
    const label = isSite('bingeflix') ? 'Program' : 'Episode'
    return (
      <div className="timer-prompt" style={ background }>
        <div className="next-episode-timer">
          Next {this.props.isPlaylistItem ? 'Video' : label } {this.props.nextVideoTitle} will start in {this.state.timer}
        </div>
      </div>
    )
  }
}

export default NextVideoTimer
